declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export function trackEvent(action: string, params?: Record<string, any>) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', action, params);
  }
}
